import React from 'react';
import { profile } from '../mock';
import { Github, Linkedin, Mail, Phone } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-cyan-400/15 mt-10">
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 py-10">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <div className="display text-lg text-cyan-100 tracking-wider">ASTRA // LUMEN&nbsp;II</div>
            <div className="mono text-[11px] tracking-[0.3em] text-cyan-400/70 mt-1">PORTFOLIO &middot; v1.0 &middot; {new Date().getFullYear()}</div>
          </div>
          <div className="flex flex-wrap gap-2">
            <a href={profile.github} target="_blank" rel="noreferrer" className="btn-ghost rounded-md px-3 py-2 mono text-[11px] tracking-[0.25em] inline-flex items-center gap-2"><Github size={13} /> GITHUB</a>
            <a href={profile.linkedin} target="_blank" rel="noreferrer" className="btn-ghost rounded-md px-3 py-2 mono text-[11px] tracking-[0.25em] inline-flex items-center gap-2"><Linkedin size={13} /> LINKEDIN</a>
            <a href={`mailto:${profile.email}`} className="btn-ghost rounded-md px-3 py-2 mono text-[11px] tracking-[0.25em] inline-flex items-center gap-2"><Mail size={13} /> EMAIL</a>
            <a href={`tel:${profile.phone.replace(/\s/g,'')}`} className="btn-ghost rounded-md px-3 py-2 mono text-[11px] tracking-[0.25em] inline-flex items-center gap-2"><Phone size={13} /> CALL</a>
          </div>
        </div>
        <div className="divider-line my-6" />
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 mono text-[11px] text-cyan-300/60">
          <span>© {new Date().getFullYear()} Pribin K Benny — All signals reserved.</span>
          <span>Built with React Three Fiber &middot; Drei &middot; Tailwind &middot; Shadcn</span>
        </div>
      </div>
    </footer>
  );
}
